import React, { useEffect, useState } from "react";
import PageTitleBanner from "./Common/PageTitleBanner";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { NOTEBOOKURL } from "../Config";
import { handleAccordian } from "../LayoutFunction";
import MapComponent from "./MapComponent";
// import DirectionButton from "./DirectionButton";

const ContactUs = () => {


  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const [BranchList, setBranchList] = useState([])
  const [formData, setFormData] = useState({
    UserName: {
      textValue: "",
      required: true,
    },
    PhoneNumber: {
      textValue: "",
      required: true,
      valid: false,
    },
    Message: {
      textValue: "",
      required: false,
    },
  });
  const [mainContactData, setMainContactData] = useState({});
  useEffect(() => {
    getContactData();
    handleAccordian()
  }, []);
  const getContactData = async () => {
    const res = await fetch(`${NOTEBOOKURL}ContactUs/GetContactUs`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ContactUsID: "",
        OfficeType: "",
        StartDate: "",
        EndDate: "",
        PaginationID: "-1",
        PageLength: "",
      }),
    });
    const result = await res.json();
    console.log(result, "result");
    setMainContactData(result.data[0]);
    const filterBranch = result.data.filter((item, index) => {
      return item.OfficeType === "Branch"
    })
    console.log(filterBranch)
    setBranchList(filterBranch)
  };
  const handleInputChange = (e) => {
    let lastInputString = e.target.value[e.target.value.length - 1];
    console.log(lastInputString);
    if (e.target.name == "PhoneNumber") {
      if (
        e.target.value == "" ||
        (lastInputString.charCodeAt() >= 48 &&
          lastInputString.charCodeAt() <= 57)
      ) {
        setFormData({
          ...formData,
          [e.target.name]: {
            ...formData[e.target.name],
            textValue: e.target.value,
            valid: e.target.value.length === 10 ? true : false,
          },
        });
      } else {
        return;
      }
      return;
    }
    setFormData({
      ...formData,
      [e.target.name]: {
        ...formData[e.target.name],
        textValue: e.target.value,
      },
    });
  };
  const handleSubmit = async (e) => {
    debugger
    e.preventDefault();
    setIsSubmit(true);
    console.log(formData, "formData");
    let validForm = true;
    for (let key in formData) {
      if (formData[key].required) {
        if (!formData[key].textValue) {
          validForm = false;
        }

        if (!validForm) {
          return;
        }
      }
    }
    if (formData.PhoneNumber.textValue.length !== 10) {
      setFormData((prev) => {
        let updatedValue = {
          ...prev,
          PhoneNumber: {
            ...prev.PhoneNumber,
            valid: false,
          },
        };
        return updatedValue;
      });
      validForm = false;

      if (validForm == false) {
        return;
      }
    }

    if (formData.UserName.textValue.length <= 2) {
      return;
    }

    console.log(formData);
    try {
      const res = await fetch(
        `${NOTEBOOKURL}ContactInquiry/SetContactInquiry`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Name: formData.UserName.textValue,
            MobileNo: formData.PhoneNumber.textValue,
            Description: formData.Message.textValue,
          }),
        }
      );
      const result = await res.json();
      console.log(result, "result");
      if (result.status === 1) {
        Swal.fire({
          title: "Submited Successfully",
          icon: "success",
          timer: 1500,
        });
        setFormData({
          UserName: {
            textValue: "",
            required: true,
          },
          PhoneNumber: {
            textValue: "",
            required: true,
            valid: false,
          },
          Message: {
            textValue: "",
            required: false,
          },
        });
        setIsSubmit(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  console.log(mainContactData, "mainContactDatamainContactData")

  return (
    <>
      <PageTitleBanner title={"Contact Us"} />
      <div className="site-content">
        <div className="container">
          <div style={{ margin: "50px 0px" }} className="row">
            <div className="col-sm-4">
              <div className="fp-section-title clearfix">
                <h2>Contact details</h2>
              </div>
              <div className="fp-icon-box-5 icon-center dark-version ">
                <span className="fp-icon">
                  <i className="factory-people" />
                </span>
                <h4>Contact Person</h4>
                <div className="sub-title" />
                <div className="desc">
                  <p>{mainContactData?.ContactPerson1}</p>
                </div>
              </div>
              <div className="fp-icon-box-5 icon-center dark-version ">
                <span className="fp-icon">
                  <i className="factory-travel" />
                </span>
                <h4>Address</h4>
                <div className="sub-title" />
                <div className="desc">
                  <p>{mainContactData?.Address}</p>
                </div>
              </div>
              <div className="fp-icon-box-5 icon-center dark-version ">
                <span className="fp-icon">
                  <i className="factory-technology" />
                </span>
                <h4>Call Us</h4>
                <div className="sub-title" />
                <div className="desc">
                  <p><a style={{ color: '#c8c8c8' }} href={"tel:" + mainContactData?.MobileNo1}></a>{mainContactData?.MobileNo1}</p>
                  <p><a style={{ color: '#c8c8c8' }} href={"tel:" + mainContactData?.MobileNo2}></a>{mainContactData?.MobileNo2}</p>
                </div>
              </div>

              {(BranchList.length > 0) &&
                <div className="fp-icon-box-5 icon-center dark-version ">
                  <div className="sub-title" />
                  {/* <div style={{
                  width: "400px",
                  position: "relative",
                  right: "10px"
                }} className="desc"> */}
                  <div style={{
                    position: "relative"
                  }} className="desc">
                    <div className="faqacrd margbtm40">
                      <div className="fp-faq ">

                        <h2>
                          <span style={{ position: "relative", right: "10px", top: "5px" }} className="fp-icon">
                            <i className="factory-travel" />
                          </span>
                          View Additional Details
                          <i
                            className="fa fa-arrow-circle-o-right"
                            aria-hidden="true"
                          ></i>
                        </h2>
                        <div className="toggle-content" style={{ overflow: "auto", maxHeight: "200px" }}>
                          {BranchList.map((item, index) => (
                            <>
                              <li key={index} className="contact-item">
                                <div className="contact-info"> {item.ContactPerson1}</div>
                                <div className="address"> {item.Address}</div>
                                <div className="contact-info"> {item.MobileNo1}</div>
                              </li>
                              {index !== BranchList.length - 1 && <hr style={{
                                marginTop: "15px",
                                marginBottom: "15px"
                              }} />}
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div>
            <div className="col-sm-8">
              <div className="fp-section-title clearfix custom-title ">
                <h2>Contact Us</h2>
              </div>
              <div className="fp-form fp-form-3  paddtop40">
                <form method="post" onSubmit={handleSubmit} id="contact-form">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group field">
                        <input
                          name="UserName"
                          value={formData.UserName.textValue}
                          onChange={handleInputChange}
                          placeholder="Your Name"
                          type="text"
                        />
                        {isSubmit &&
                          formData.UserName.textValue.length <= 2 && (
                            <span style={{ color: "red" }}>
                              Please Enter Name
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group field">
                        <input
                          name="PhoneNumber"
                          maxLength={10}
                          value={formData.PhoneNumber.textValue}
                          onChange={handleInputChange}
                          placeholder="Phone"
                          type="text"
                        />
                        {isSubmit && !formData.PhoneNumber.valid && (
                          <span style={{ color: "red" }}>
                            Please Enter Phone Number
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <textarea
                          name="Message"
                          value={formData.Message.textValue}
                          onChange={handleInputChange}
                          placeholder="Message"
                          maxLength={150}
                        />
                        {/* {isSubmit && formData.Message.textValue  && (
                          <span style={{ color: "red" }}>
                            Please Enter Your Requirement
                          </span>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-12 submit text-center paddtop30 pb-10">
                      <input
                        type="submit"
                        defaultValue="Submit Now"
                        className="fh-btn"
                      />
                    </div>
                    <MapComponent latitude={parseFloat(mainContactData?.Latitude)} longitude={parseFloat(mainContactData?.Longitude)} Address={mainContactData?.Address} />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
